import React from 'react'
import { Toast as BootStrapToast } from 'react-bootstrap'
import { SVGIcon, SVGIconType } from './svgicon'

export const Toast = (p: {
  toastCopy: React.ReactNode
  onClose: () => void
  iconId?: SVGIconType
  isVisible?: boolean
  extraClasses?: string
}) => {
  return (
    <BootStrapToast
      animation={true}
      autohide={true}
      delay={3000}
      show={p.isVisible}
      onClose={p.onClose}
      onClick={p.onClose}
      className={`toast--success ${p.extraClasses || ''}`}
    >
      <BootStrapToast.Body as="p">
        {p.iconId && <SVGIcon iconId={p.iconId} size={20} />}
        {p.toastCopy}
      </BootStrapToast.Body>
    </BootStrapToast>
  )
}
